"use strict";

exports.__esModule = true;
exports.generateTableProps = void 0;
var _helpers = require("../DataTable/helpers");
var generateTableProps = exports.generateTableProps = function generateTableProps(_ref) {
  var columns = _ref.columns,
    height = _ref.height,
    width = _ref.width,
    pagination = _ref.pagination,
    setPagination = _ref.setPagination;
  // $FlowIgnore Convert the incoming sorting configs in to table component sorting format
  var defaultSortOrder = (0, _helpers.getDefaultSortOrder)(columns);
  return {
    manual: true,
    applyPagination: function applyPagination(updatedData) {
      return updatedData.slice(pagination.page * pagination.pageSize, (pagination.page + 1) * pagination.pageSize);
    },
    page: pagination.page,
    showPagination: true,
    pageSize: pagination.pageSize,
    pageSizes: [25, 50, 100, 250],
    height: height,
    width: width,
    style: {
      height: height + "px",
      width: width + "px"
    },
    defaultSorted: defaultSortOrder.map(function (_ref2) {
      var id = _ref2.id,
        desc = _ref2.desc;
      return {
        id: id,
        desc: desc
      };
    }),
    onFetchData: function onFetchData(_ref3) {
      var page = _ref3.page,
        pageSize = _ref3.pageSize;
      return setPagination({
        page: page,
        pageSize: pageSize
      });
    }
  };
};